module.exports = __webpack_public_path__ + "static/media/5.27b2366a.jpg";